export const NAME = "productList" as const;

export const PRODUCT_BRAND_MODAL_ID = "productBrandModal" as const;
export const PRODUCT_PACKAGE_MODAL_ID = "productPackageModal" as const;
